import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const SearchPatientList = async (
  formattedValue,
  onChange,
  callbackFn,
  searchMode
) => {
  callbackFn('FoundPatient', 0);
  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_PATIENT_SEARCH_IN_LIST}`,
    true,
    {
      [searchMode]: formattedValue,
      topRecord: 10,
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      callbackFn('FoundPatient', response.data.Data.lst);
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
